/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo } from "react";
import { BEM } from "@adapptio/lib-components";
import { CodeEditor } from "@adapptio/lib-editor-ui";
import { ResourceDebugView } from "../../ResourceDebugView";

import "./ResourceDebugViewDebugger.scss";

export interface IResourceDebugViewDebuggerProps {
	className?: string;
	view: ResourceDebugView;
}

export const ResourceDebugViewDebugger: React.FC<IResourceDebugViewDebuggerProps> = ({ className, view }) => {
	const baseClass = BEM("edt-resource-debug-view-debugger");

	const resource = useMemo(() => view.getResource(), [ view ]);

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			<CodeEditor language="yaml" readOnly value={resource.content} />
		</div>
	);
};
